var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinitoreGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1034 3939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.406,428.565l-1.316-1.958h-4.484a8.562,8.562,0,0,0-.46-.757V419H130v4.164a7.844,7.844,0,0,0-5.168-.573l.051.024.444,1.907.016.036A6.309,6.309,0,0,0,126.6,437a5.968,5.968,0,0,0,3.834-1.4l.053.114,1.486,1.209L132,436.9a8.2,8.2,0,0,0,1.428-1.786h4.662l1.316-1.958H143.5v-4.594Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.708,430.711A6.106,6.106,0,1,0,126.6,437a6.2,6.2,0,0,0,6.1-6.289",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,436.9a8.5,8.5,0,0,0,1.782-10.007,8,8,0,0,0-8.948-4.3",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.842,
    transform: "translate(1044.003 -3936)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,419h3.143v6.641",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.778,426.607h4.313l1.316,1.958H143.5v4.594",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.778,435.117h4.313l1.316-1.958H143.5",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.486,
    y2: 1.209,
    transform: "translate(1044.49 -3919.284)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.443,
    y1: 1.906,
    transform: "translate(1038.886 -3932.385)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1034 -3939)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinitoreGreen);
export default __webpack_public_path__ + "static/media/finitore_green.9fbadeabb6efef31a726c75c073d3cf1.svg";
export { ForwardRef as ReactComponent };